import { render, staticRenderFns } from "./DashboardSendSMS.vue?vue&type=template&id=2e49a281&scoped=true&"
import script from "./DashboardSendSMS.vue?vue&type=script&lang=js&"
export * from "./DashboardSendSMS.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSendSMS.vue?vue&type=style&index=0&id=2e49a281&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49a281",
  null
  
)

export default component.exports